import DashboardLayout from "@/components/DashboardLayout";
import FinanceSummaryDashboard from "@/pages/FinanceSummaryDashboard";

export default function Accounting() {
  return (
    <DashboardLayout>
      <div className="space-y-6">
        <FinanceSummaryDashboard />
      </div>
    </DashboardLayout>
  );
}
